import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'src/redux/store';
import { promoteGroupAdmin, demoteGroupAdmin, removeGroupParticipant } from 'src/redux/slices/chat';
import Iconify from 'src/components/Iconify';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from 'src/@/components/ui/dropdown-menu';
import { Button } from 'src/@/components/ui/button';

export default function MemberMenu({ chatId, member }) {
  const { t } = useTranslation('chat');
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const onPromote = async () => {
    const r = await dispatch(promoteGroupAdmin(chatId, member.wa_id));
    enqueueSnackbar(
      r?.success ? t('groups.participants.promoted', 'Promovido a admin') : (r?.message || t('whatsappBusiness.error', 'Erro')),
      { variant: r?.success ? 'success' : 'error' }
    );
  };

  const onDemote = async () => {
    const r = await dispatch(demoteGroupAdmin(chatId, member.wa_id));
    enqueueSnackbar(
      r?.success ? t('groups.participants.demoted', 'Rebaixado') : (r?.message || t('whatsappBusiness.error', 'Erro')),
      { variant: r?.success ? 'success' : 'error' }
    );
  };

  const onRemove = async () => {
    const r = await dispatch(removeGroupParticipant(chatId, member.wa_id));
    enqueueSnackbar(
      r?.success ? t('groups.participants.removed', 'Removido do grupo') : (r?.message || t('whatsappBusiness.error', 'Erro')),
      { variant: r?.success ? 'success' : 'error' }
    );
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="h-7 w-7">
          <Iconify icon="eva:more-vertical-fill" width={14} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44">
        {!member.isAdmin ? (
          <DropdownMenuItem onClick={onPromote}>
            <Iconify icon="solar:crown-line-duotone" width={14} className="mr-2 text-yellow-600" />
            {t('groups.participants.promote', 'Promover a admin')}
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem onClick={onDemote}>
            <Iconify icon="solar:user-minus-rounded-bold" width={14} className="mr-2" />
            {t('groups.participants.demote', 'Rebaixar admin')}
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onRemove} className="text-red-600 focus:text-red-700">
          <Iconify icon="solar:trash-bin-trash-bold" width={14} className="mr-2" />
          {t('groups.participants.remove', 'Remover do grupo')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
